

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import RestClient, { RestError, ServerError, ValidationError } from "../RestClient";
import DemoServer from "../shared/DemoServer";
import Utils from "../shared/Utils";
import DateFormatter from "../shared/DateFormatter";

import { HolidayProgramBookingForm } from "../shared/DemoData";

import Loading from "../components/general/Loading.vue";
import TextView from "../components/controls/TextView.vue";
import ApprovalList from "../components/controls/ApprovalList.vue";

import { SettingsPublicJson } from "../shared/SettingsJson";
import HolidayProgramJson from "../shared/HolidayProgramJson";
import { HolidayProgramBookingStatus } from "../shared/HolidayProgramBookingStatus";
import HolidayProgramPriceJson from "../shared/HolidayProgramPriceJson";
import { HolidayProgramInfoJson } from "../shared/HolidayProgramJson";
import HolidayProgramBookingJson, { defaultHolidayProgramBookingJson } from "../shared/HolidayProgramBookingJson";
import CustomerJson, { defaultCustomerJson } from "../shared/CustomerJson";
import SepaMandateJson from "../shared/SepaMandateJson";

import { Gender } from "../shared/Gender";
import { validateHolidayProgramBookingJsonBookingForm } from "../shared/HolidayProgramBookingJson";
import { ValidationResult, Validation, ValidationErrorType } from "../shared/Validation";

import CustomContent from "../components/custom/HolidaysRegistration";

export default Vue.extend({
  name: "ferienbetreuung",
  components: {
    Loading,
    TextView,
    ApprovalList,
  },
  data() {
    return {
      RestClient: RestClient,
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      FormDemoData: HolidayProgramBookingForm,
      Gender: Gender,
      CustomContent: CustomContent,
      urlParams: null as URLSearchParams | null,
      embeddedStyle: false as boolean,
      supportsDatePicker: false,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      maxCustomersPerBooking: 5,
      settings: null as SettingsPublicJson | null,
      programInfos: null as HolidayProgramInfoJson[] | null,
      selectedProgramInfoIndex: null as any[] | null,
      selectedProgramInfoIds: [] as any[],
      bookingDetails: null as HolidayProgramBookingJson | null,
      cachedPrices: {} as { [index: number]: any },
      cachedCustomerGuardian: { addressCountry: "Deutschland" } as Pick<
        CustomerJson,
        | "guardianFirstName"
        | "guardianLastName"
        | "email"
        | "phone"
        | "addressStreet"
        | "addressZip"
        | "addressCity"
        | "addressCountry"
      >,
      cachedCustomersBirthDates: [] as string[],
      showEmployerInputs: false as boolean,
      validation: null as ValidationResult<HolidayProgramBookingJson> | null,
      toValidate: {} as any,
      submitValidation: false,
      differentAddress: false,
      frontendValidations: {
        simultanousPrograms: false,
        minimumAge: false,
        maximumAge: false,
        requiresSelectedDiscountInfo: false,
        requiresAllGuardiansEmployed: false,
        neededIsSingleParent: false,
        minimumClass: false,
        maximumClass: false,
        requiresEmployerInputs: false,
      },
      showValidationWarnung: false as boolean,
      submitLoading: false as boolean,
      submitErrorMessages: {} as { [index: number]: string },
      submitCompleted: false as boolean,
    };
  },
  created() {
    this.getUrlParams();
    this.initBooking();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.checkUseDemoData();
  },
  methods: {
    getUrlParams() {
      this.urlParams = new URL(location.href).searchParams;
    },

    async initBooking() {
      await this.loadPublicSettings();
      await this.loadProgramInfos();
      await this.loadProgramBookingDetails();

      if (this.urlParams != null) {
        this.embeddedStyle = Utils.getUrlParamBool(this.urlParams.get("embedded"));

        let holidayProgramId = Utils.getUrlParamNum(this.urlParams.get("holidayProgramId"));
        if (holidayProgramId) {
          this.selectedProgramInfoIds = [holidayProgramId];
          this.onChangeSelectedProgramInfoIds(holidayProgramId);
        }
      }
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>document.querySelector("#testDatePicker input");

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    checkUseDemoData() {
      if (process.env.NODE_ENV == "development") {
        const vue = this;

        window.addEventListener("keypress", function (e) {
          if (e.altKey && e.key == "¡") {
            //vue.cachedCustomerGuardian = { ...vue.FormDemoData }
            //vue.bookingDetails = JSON.parse(JSON.stringify(vue.FormDemoData))
          }
        });
      }
    },

    async loadPublicSettings() {
      try {
        this.settings = await this.RestClient.getPublicSettings();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadProgramInfos() {
      try {
        this.programInfos = await this.RestClient.getHolidayProgramInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadProgramBookingDetails() {
      this.bookingDetails = {
        /*
        ID: null,
        title: this.selectedProgramBookingDetails.title,
        remarks: this.selectedProgramBookingDetails.remarks,
        beginDate: this.selectedProgramBookingDetails.beginDate,
        endDate: this.selectedProgramBookingDetails.endDate,
        basePrice: this.selectedProgramBookingDetails.basePrice,
        discountPrices: this.selectedProgramBookingDetails.discountPrices,
        addonPrices: this.selectedProgramBookingDetails.addonPrices,
        allowRegistration: this.selectedProgramBookingDetails.allowRegistration,
        registrationBeginDateTime: this.selectedProgramBookingDetails.registrationBeginDateTime,
        registrationEndDateTime: this.selectedProgramBookingDetails.registrationEndDateTime,
        registrationMaximumCount: this.selectedProgramBookingDetails.registrationMaximumCount,
        */

        ...defaultHolidayProgramBookingJson(),
        sepaMandate: this.getDefaultSepaMandate(),
      };

      // used to show demo email
      this.cachedCustomerGuardian.email = this.bookingDetails.customers[0].email;
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      //todo: if else notwendig?
      if (this.cachedCustomerGuardian != null) {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.cachedCustomerGuardian.guardianFirstName,
          accountHolderLastName: this.cachedCustomerGuardian.guardianLastName,
          addressStreet: this.cachedCustomerGuardian.addressStreet,
          addressZip: this.cachedCustomerGuardian.addressZip,
          addressCity: this.cachedCustomerGuardian.addressCity,
          addressCountry: this.cachedCustomerGuardian.addressCountry,
          IBAN: "",
          BIC: "",
        };
      } else {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: "",
          accountHolderLastName: "",
          addressStreet: "",
          addressZip: "",
          addressCity: "",
          addressCountry: "Deutschland",
          IBAN: "",
          BIC: "",
        };
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.bookingDetails != null) {
        this.validation = validateHolidayProgramBookingJsonBookingForm(this.bookingDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /* START frontend validation */

    frontendValidation() {
      this.validateSimultanousPrograms();
      this.validateAge();
      this.validateRequiredSelectedDiscountInfo();
      this.validateAllGuardiansEmployed();
      this.validateRequiredEmployerInputs();
      this.validateChildrenGradeLevel();
    },

    validateSimultanousPrograms() {
      if (this.selectedProgramInfos !== undefined) {
        this.frontendValidations.simultanousPrograms = false;

        for (let i = 0; i < this.selectedProgramInfos.length; i++) {
          let date = this.selectedProgramInfos[i].beginDate;

          let result = this.selectedProgramInfos.filter((item) => item.beginDate == date);

          if (result.length > 1) {
            this.frontendValidations.simultanousPrograms = true;
            break;
          }
        }
      }
    },

    validateAge() {
      if (
        this.selectedProgramInfos !== undefined &&
        this.bookingDetails != null &&
        this.bookingDetails.customers != null
      ) {
        this.frontendValidations.minimumAge = false;
        this.frontendValidations.maximumAge = false;

        for (let item of this.selectedProgramInfos) {
          let beginDate = item.beginDate;

          for (let c of this.bookingDetails.customers) {
            if (c.childBirthDate) {
              let testDate = new Date(beginDate);
              let birthDate = new Date(c.childBirthDate);

              let age = testDate.getFullYear() - birthDate.getFullYear();
              let month = testDate.getMonth() - birthDate.getMonth();
              if (month < 0 || (month === 0 && testDate.getDate() < birthDate.getDate())) {
                age--;
              }

              if (item.restrictMinimumAge != null && age < item.restrictMinimumAge) {
                this.frontendValidations.minimumAge = true;
              }

              if (item.restrictMaximumAge != null && age > item.restrictMaximumAge) {
                this.frontendValidations.maximumAge = true;
              }
            }
          }
        }
      }
    },

    validateRequiredSelectedDiscountInfo() {
      if (this.bookingDetails != null) {
        this.frontendValidations.requiresSelectedDiscountInfo = false;

        for (let i in this.cachedPrices) {
          if (this.cachedPrices[i].selectedDiscount.requiresSelectedDiscountInfo) {
            if (
              this.bookingDetails.selectedDiscountInfo == null ||
              this.bookingDetails.selectedDiscountInfo.trim().length <= 0
            ) {
              this.frontendValidations.requiresSelectedDiscountInfo = true;
            }
          }
        }
      }
    },

    validateAllGuardiansEmployed() {
      if (this.bookingDetails != null) {
        this.frontendValidations.requiresAllGuardiansEmployed = false;
        this.frontendValidations.neededIsSingleParent = false;

        for (let i in this.cachedPrices) {
          if (this.cachedPrices[i].selectedDiscount.requiresAllGuardiansEmployed) {
            this.frontendValidations.requiresAllGuardiansEmployed = true;

            if (this.bookingDetails.isSingleParent == null) {
              this.frontendValidations.neededIsSingleParent = true;
            } else {
              if (this.bookingDetails.isSingleParent && this.bookingDetails.isWorking) {
                this.frontendValidations.requiresAllGuardiansEmployed = false;
              }

              if (
                this.bookingDetails.isSingleParent == false &&
                this.bookingDetails.isWorking &&
                this.bookingDetails.isPartnerWorking
              ) {
                this.frontendValidations.requiresAllGuardiansEmployed = false;
              }
            }
          }
        }
      }
    },

    validateRequiredEmployerInputs() {
      this.frontendValidations.requiresEmployerInputs = false;

      if (this.showEmployerInputs && this.bookingDetails != null) {
        let check = false;

        for (let i in this.cachedPrices) {
          if (this.cachedPrices[i].selectedDiscount.requiresEmployerInputs) {
            check = true;
            break;
          }
        }

        if (check) {
          if (this.bookingDetails.isWorking && this.bookingDetails.employerFirst == "") {
            this.frontendValidations.requiresEmployerInputs = true;
          } else if (this.bookingDetails.isPartnerWorking && this.bookingDetails.employerSecond == "") {
            this.frontendValidations.requiresEmployerInputs = true;
          }
        }
      }
    },

    validateChildrenGradeLevel() {
      if (
        this.selectedProgramInfos !== undefined &&
        this.bookingDetails != null &&
        this.bookingDetails.customers != null
      ) {
        this.frontendValidations.minimumClass = false;
        this.frontendValidations.maximumClass = false;

        for (let i in this.cachedPrices) {
          const minClass = this.cachedPrices[i].selectedDiscount.childrenClassMinimum;
          const maxClass = this.cachedPrices[i].selectedDiscount.childrenClassMaximum;

          for (let c of this.bookingDetails.customers) {
            if (c.childGradeLevel) {
              if (minClass != null && minClass > c.childGradeLevel) {
                this.frontendValidations.minimumClass = true;
              }

              if (maxClass != null && maxClass < c.childGradeLevel) {
                this.frontendValidations.maximumClass = true;
              }
            }
          }
        }
      }
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    /* END frontend validation */

    onChangeSelectedProgramInfoIds(programId: number) {
      this.addAndRemoveCachedPricesProgram(programId);
      this.frontendValidation();
    },

    addAndRemoveCachedPricesProgram(programId: number) {
      if (programId in this.cachedPrices) {
        delete this.cachedPrices[programId];
      } else {
        if (this.programInfos != null) {
          let priceInfo = this.programInfos.find((i) => i.ID == programId)?.basePrice;

          this.cachedPrices[programId] = {
            selectedDiscount: {
              title: null,
              remarks: "",
              priceFirstChild: priceInfo !== undefined ? priceInfo.priceFirstChild : 0,
              priceAdditionalChild: priceInfo !== undefined ? priceInfo.priceAdditionalChild : 0,
              cancellationFee: priceInfo !== undefined ? priceInfo.cancellationFee : 0,
              cancellationRemarks: priceInfo !== undefined ? priceInfo.cancellationRemarks : "",
              requiresSelectedDiscountInfo:
                priceInfo !== undefined ? priceInfo.requiresSelectedDiscountInfo : undefined,
              requiresAllGuardiansEmployed:
                priceInfo !== undefined ? priceInfo.requiresAllGuardiansEmployed : undefined,
              childrenClassMinimum: priceInfo !== undefined ? priceInfo.childrenClassMinimum : null,
              childrenClassMaximum: priceInfo !== undefined ? priceInfo.childrenClassMaximum : null,
            },
            selectedExtras: [],
          };
        }
      }
    },

    setSelectedPriceInfo(selectedProgramIndex: number, selectedProgramId: number) {
      if (this.selectedProgramInfos != null) {
        let selectedPriceInfo;

        if (this.cachedPrices[selectedProgramId].selectedDiscount.title == null) {
          selectedPriceInfo = this.selectedProgramInfos[selectedProgramIndex].basePrice;
        } else {
          selectedPriceInfo = this.selectedProgramInfos[selectedProgramIndex].discountPrices.find(
            (i: HolidayProgramPriceJson) => i.title == this.cachedPrices[selectedProgramId].selectedDiscount.title
          );
        }

        if (selectedPriceInfo !== undefined) {
          this.cachedPrices[selectedProgramId].selectedDiscount.remarks = selectedPriceInfo.remarks;
          this.cachedPrices[selectedProgramId].selectedDiscount.priceFirstChild = selectedPriceInfo.priceFirstChild;
          this.cachedPrices[selectedProgramId].selectedDiscount.priceAdditionalChild =
            selectedPriceInfo.priceAdditionalChild;
          this.cachedPrices[selectedProgramId].selectedDiscount.cancellationFee = selectedPriceInfo.cancellationFee;
          this.cachedPrices[selectedProgramId].selectedDiscount.cancellationRemarks =
            selectedPriceInfo.cancellationRemarks;
          this.cachedPrices[selectedProgramId].selectedDiscount.requiresSelectedDiscountInfo =
            selectedPriceInfo.requiresSelectedDiscountInfo;
          this.cachedPrices[selectedProgramId].selectedDiscount.requiresAllGuardiansEmployed =
            selectedPriceInfo.requiresAllGuardiansEmployed;
          this.cachedPrices[selectedProgramId].selectedDiscount.childrenClassMinimum =
            selectedPriceInfo.childrenClassMinimum;
          this.cachedPrices[selectedProgramId].selectedDiscount.childrenClassMaximum =
            selectedPriceInfo.childrenClassMaximum;
          this.cachedPrices[selectedProgramId].selectedDiscount.showEmployerInputs =
            selectedPriceInfo.showEmployerInputs;
          this.cachedPrices[selectedProgramId].selectedDiscount.requiresEmployerInputs =
            selectedPriceInfo.requiresEmployerInputs;
        }

        this.checkShowEmployerInputs();

        this.$forceUpdate();
      }
    },

    addCustomer() {
      if (this.bookingDetails != null) {
        if (this.bookingDetails.customers.length < this.maxCustomersPerBooking) {
          this.bookingDetails.customers.push(this.getDefaultCustomer());
        }
      }
    },

    deleteCustomer(index: number) {
      if (this.bookingDetails != null && this.bookingDetails.customers != null) {
        if (this.bookingDetails.customers.length > 1) {
          this.bookingDetails.customers.splice(index, 1);
          this.cachedCustomersBirthDates.splice(index, 1);

          //delete this.toValidate['customer-'+index]
        } else {
          alert("Es muss mindestens ein Kind angemeldet werden.");
        }
      }
    },

    setCustomersBirthDates(customer: number) {
      if (this.bookingDetails != null && this.bookingDetails.customers != null) {
        var birthDate = "";

        if (this.supportsDatePicker) {
          birthDate = this.cachedCustomersBirthDates[customer];
        } else {
          if (this.cachedCustomersBirthDates[customer].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedCustomersBirthDates[customer]);

            if (d != null) {
              birthDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.bookingDetails.customers[customer].childBirthDate = birthDate;
      }
    },

    async submitForm() {
      //check selected holidayPrograms
      if (this.selectedProgramInfoIds.length > 0) {
        if (this.bookingDetails != null) {
          this.submitLoading = true;

          //add guardian info to all customers (from cachedCustomerGuardian)
          this.addCustomerGuardian();

          //set different address
          if (!this.differentAddress) {
            this.setDifferentAddress();
          }

          //add dateTime to sepa mandate
          if (this.bookingDetails.sepaMandate != null) {
            let now = new Date().toISOString();
            this.bookingDetails.sepaMandate.dateTime = now;
          }

          //final validation
          this.frontendValidation();
          this.validation = validateHolidayProgramBookingJsonBookingForm(this.bookingDetails);
          this.submitValidation = true;

          //start submit if aprovals and validation is correct
          if (
            (this.$refs.approvalRequired as any).validate() &&
            this.checkFrontendValidations() &&
            this.validation != null &&
            this.validation.isValid == true
          ) {
            for (let i = 0; i < this.selectedProgramInfoIds.length; i++) {
              this.addCancellationInfo(this.selectedProgramInfoIds[i]);
              this.addDiscountAndAddonPrices(this.selectedProgramInfoIds[i]);
              await this.submitProgramBooking(this.selectedProgramInfoIds[i]);
            }

            this.submitCompleted = true;
            this.submitLoading = false;
          } else {
            this.showValidationWarnung = true;
            this.submitLoading = false;
          }
        }
      } else {
        alert("Es muss mindestens ein Ferienprogramm ausgewählt werden.");
      }
    },

    async submitProgramBooking(programId: number) {
      if (this.bookingDetails != null) {
        try {
          await this.RestClient.requestHolidayProgramBooking(programId, this.bookingDetails);
        } catch (e) {
          if (e.hasOwnProperty("validationResult")) {
            if (e.validationResult.errors.bookingDateTime == ValidationErrorType.tooManySimultanous) {
              this.submitErrorMessages[programId] = "Derzeit stehen leider nicht ausreichend Plätze zur Verfügung.";
            }
          } else {
            this.submitErrorMessages[programId] = e.message;
          }
        }
      }
    },

    addCancellationInfo(programId: number) {
      if (this.bookingDetails != null) {
        this.bookingDetails.cancellationFee = this.cachedPrices[programId].selectedDiscount.cancellationFee;
        this.bookingDetails.cancellationRemarks = this.cachedPrices[programId].selectedDiscount.cancellationRemarks;
      }
    },

    addDiscountAndAddonPrices(programId: number) {
      if (this.bookingDetails != null) {
        //discountPrice
        this.bookingDetails.selectedDiscount = null;
        this.bookingDetails.selectedDiscount = this.cachedPrices[programId].selectedDiscount.title;

        //addonPrices
        this.bookingDetails.selectedExtras = [];
        this.bookingDetails.selectedExtras = this.cachedPrices[programId].selectedExtras;
      }
    },

    addCustomerGuardian() {
      if (this.bookingDetails != null && this.bookingDetails.customers != null) {
        for (let i = 0; i < this.bookingDetails.customers.length; i++) {
          this.bookingDetails.customers[i].guardianFirstName = this.cachedCustomerGuardian.guardianFirstName;
          this.bookingDetails.customers[i].guardianLastName = this.cachedCustomerGuardian.guardianLastName;
          this.bookingDetails.customers[i].email = this.cachedCustomerGuardian.email;
          this.bookingDetails.customers[i].phone = this.cachedCustomerGuardian.phone;
          this.bookingDetails.customers[i].addressStreet = this.cachedCustomerGuardian.addressStreet;
          this.bookingDetails.customers[i].addressZip = this.cachedCustomerGuardian.addressZip;
          this.bookingDetails.customers[i].addressCity = this.cachedCustomerGuardian.addressCity;
          this.bookingDetails.customers[i].addressCountry = this.cachedCustomerGuardian.addressCountry;
        }
      }
    },

    setDifferentAddress() {
      if (this.bookingDetails != null) {
        if (this.bookingDetails.customers != null && this.bookingDetails.sepaMandate != null) {
          this.bookingDetails.sepaMandate.accountHolderFirstName = this.bookingDetails.customers[0].guardianFirstName;
          this.bookingDetails.sepaMandate.accountHolderLastName = this.bookingDetails.customers[0].guardianLastName;

          this.bookingDetails.sepaMandate.addressStreet = this.bookingDetails.customers[0].addressStreet;
          this.bookingDetails.sepaMandate.addressZip = this.bookingDetails.customers[0].addressZip;
          this.bookingDetails.sepaMandate.addressCity = this.bookingDetails.customers[0].addressCity;
          this.bookingDetails.sepaMandate.addressCountry = this.bookingDetails.customers[0].addressCountry;
        }
      }
    },

    holidayProgramSlotState(programInfo: HolidayProgramInfoJson) {
      if (programInfo.registrationSlotsFree <= 0) {
        if (programInfo.waitingListSlotsFree <= 0) {
          if (programInfo.waitingListMaximumCount > 0) {
            return "noFreeWaitingSlot";
          } else {
            return "noWaitingList";
          }
        } else {
          return "waitingList";
        }
      } else {
        return "freeSlot";
      }
    },

    getProgramSeatsLeftString(programInfo: HolidayProgramInfoJson, state: string) {
      if (state == "freeSlot") {
        let freeSeats = programInfo.registrationSlotsFree;

        if (freeSeats > 0 && freeSeats < 5) {
          return `${freeSeats} ${freeSeats == 1 ? "freier Platz" : "freie Plätze"}`;
        } else {
          return "";
        }
      } else if (state == "waitingList") {
        let freeSeats = programInfo.waitingListSlotsFree;

        if (freeSeats > 0 && freeSeats < 5) {
          return `${freeSeats} ${freeSeats == 1 ? "freier Platz" : "freie Plätze"}`;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    checkShowEmployerInputs() {
      for (let i in this.cachedPrices) {
        if (this.cachedPrices[i].selectedDiscount.showEmployerInputs) {
          this.showEmployerInputs = true;
          return true;
        }
      }

      if (this.bookingDetails) {
        this.bookingDetails.employerFirst = "";
        this.bookingDetails.employerSecond = "";
      }

      this.showEmployerInputs = false;
      return false;
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {},

  computed: {
    showAllowedToComeGoAlone(): boolean {
      if (this.settings != null) {
        return this.settings.holidayBookingShowAllowToComeGoAlone;
      } else {
        return false;
      }
    },

    bookableProgramInfos(): HolidayProgramInfoJson[] | undefined {
      if (this.programInfos != null) {
        let bookableProgramInfos = this.programInfos.filter((i: any) => i.registrationSlotsFree);

        return bookableProgramInfos;
      }
    },

    selectedProgramInfos(): HolidayProgramInfoJson[] | undefined {
      if (this.programInfos != null) {
        let selectedProgramInfos = this.programInfos.filter((i: any) => this.selectedProgramInfoIds.includes(i.ID));

        return selectedProgramInfos;
      }
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            return this.bookingDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            this.bookingDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
